// extracted by mini-css-extract-plugin
module.exports = {"game":"Game_game__DpFmy"};